export default __webpack_public_path__ + "static/media/fsiRealCase1-en.01830499.jpg";